import { styled } from 'styled-components'

import { variables } from 'core/styles'

const Content = styled.div`
  padding-right: 8px;
  max-height: 70vh;
  overflow-y: auto;
  color: ${variables.colorBlack90};
`
const Columns = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin: auto;
  max-width: 456px;
`
const Column = styled.div``
const ColumnTitle = styled.div`
  margin: 16px 0 24px;
  color: ${variables.colorBlack90};
  font-weight: 500;
`
const Identifier = styled.div`
  margin-bottom: 24px;
  color: ${variables.colorBlack70};
  font-size: 12px;
  font-weight: 500;
`
const P = styled.p`
  margin: 0 0 24px;
`

export default (
  <Content>
    <P>
      Format your search with some of the below prefixes. You can combine
      prefixes to refine your search. Use quotes to search for phrases. Some
      prefixes must <b>exactly match</b> to return results; other prefixes will
      fuzzy match—returning any close-enough results.
    </P>

    <P>
      Ex:
      <br />
      fullName:"Daniel Garcia Lopez" address:"221 Main Street"
      <br />
      firstName:Bob lastName:Borrower dateOfBirth:01/01/2010
      <br />
      businessName:”Bob’s Business” borrowerType:business
      <br />
    </P>
    <Columns>
      <Column>
        <ColumnTitle>Fuzzy match </ColumnTitle>
        <Identifier>fullName:</Identifier>
        <Identifier>email:</Identifier>
        <Identifier>city:</Identifier>
        <Identifier>address:</Identifier>
        <Identifier>bizName:</Identifier>
        <Identifier>bizEmployeeEmail:</Identifier>
        <Identifier>bizEmployeeName:</Identifier>
        <Identifier>firstName:</Identifier>
        <Identifier>lastName:</Identifier>
        <Identifier>middleName:</Identifier>
        <Identifier>maidenName:</Identifier>
        <Identifier>legalRepFirstName:</Identifier>
        <Identifier>legalRepLastName:</Identifier>
        <Identifier>legalRepEmail:</Identifier>
        <Identifier>accountIdPartial:</Identifier>
      </Column>
      <Column>
        <ColumnTitle>Exact match </ColumnTitle>
        <Identifier>taxId: (last 4 digits, i.e. SSN)</Identifier>
        <Identifier>accountId:</Identifier>
        <Identifier>caseId:</Identifier>
        <Identifier>id: (borrowerID)</Identifier>
        <Identifier>borrowerId: (borrowerID)</Identifier>
        <Identifier>bankruptcyCourtCase: (court case number)</Identifier>
        <Identifier>dateOfBirth: (MM/DD/YYYY)</Identifier>
        <Identifier>phone: (###-###-####)</Identifier>
        <Identifier>legalRepPhone: (###-###-####)</Identifier>
        <Identifier>bizEmployeePhone: (###-###-####)</Identifier>
        <Identifier>postalCode: (5 digits)</Identifier>
        <Identifier>state:</Identifier>
        <Identifier>paymentMethod: (last 4 digits)</Identifier>
        <Identifier>borrowerType: (business or person)</Identifier>
        <Identifier>emailExact:</Identifier>
        <Identifier>interactionId: (IN-XXXX-XXXX)</Identifier>
      </Column>
    </Columns>
  </Content>
)
